
import {Pipe, PipeTransform} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({name: 'trim'})
export class TrimPipe implements PipeTransform {
  transform(value: any) {
    if (!value || value == null) {
      return '';
    }
    return value.trim();
  }
}

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    value = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@Pipe({ name: 'safeUrl'})
export class SafeUrlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustResourceUrl(value.trim());
  }
}


@Pipe({ name: 'str2Nb'})
export class Str2NbPipe implements PipeTransform  {
  constructor() {}
  transform(value) {
    return parseFloat(value);
  }
}

@Pipe({
  name: 'ellipsis'
})
export class EllipsisPipe implements PipeTransform {

  transform(value: string, limit: number): any {
    if(!value || value == '')
      return '';
    if(limit && value.length > limit) {
      return value.substring(0, limit).concat('...');
    }
    return value;
  }

}